import { graphql } from "gql.tada";
import type { ResultOf } from "gql.tada";

export const GET_LINES = graphql(`
  query GetLines {
    lines {
      id
      code
    }
  }
`);

export const GET_OPERATIONAL_DATA_YEARS = graphql(`
  query GetOperationalDataYears($line: String!) {
    operationalDataYears(line: $line)
  }
`);

export const GET_OPERATIONAL_DATA = graphql(`
  query GetOperationalData($line: String!, $year: Int!) {
    operationalData(line: $line, year: $year) {
      id
      line
      year
      fields {
        field
        coachTypes {
          coachType
          months {
            month
            value
          }
        }
      }
    }
  }
`);

export type Line = ResultOf<typeof GET_LINES>["lines"][number];
export type LineOperationalData = NonNullable<
  ResultOf<typeof GET_OPERATIONAL_DATA>["operationalData"]
>;
export type OpDataFieldEntry = LineOperationalData["fields"][number];
